module.exports = __webpack_public_path__ + "img/crucipixel.c14bfada.png";